import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DasSenseHIconSvg = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26 8C28.7614 8 31 10.2386 31 13V21.1006C32.2372 22.3631 33 24.0927 33 26C33 29.866 29.866 33 26 33C22.8291 33 20.1517 30.8913 19.291 28H7C7 22.201 10.5817 19 15 19C17.2443 19 19.2708 19.8276 20.7236 21.4004C20.813 21.2979 20.9049 21.1977 21 21.1006V13C21 10.2386 23.2386 8 26 8ZM26 10C24.3431 10 23 11.3431 23 13V21.918L22.4287 22.501C21.543 23.4048 21 24.637 21 26C21 28.7614 23.2386 31 26 31C28.7614 31 31 28.7614 31 26C31 24.637 30.457 23.4048 29.5713 22.501L29 21.918V13C29 11.3431 27.6569 10 26 10ZM26 15C26.5523 15 27 15.4477 27 16V23.1709C28.1652 23.5828 29 24.6938 29 26C29 27.6569 27.6569 29 26 29C24.3431 29 23 27.6569 23 26C23 24.6938 23.8348 23.5828 25 23.1709V16C25 15.4477 25.4477 15 26 15ZM15 10C17.2091 10 19 11.7909 19 14C19 16.2091 17.2091 18 15 18C12.7909 18 11 16.2091 11 14C11 11.7909 12.7909 10 15 10Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default DasSenseHIconSvg;
